// Attachments and file handling dictionary
const dictAttachments = {
    // Main attachment labels
    board_attachments: {
        th: "ไฟล์แนบ (รูป/วิดีโอ)",
        en: "Attachments (Images/Videos)",
        ja: "添付ファイル（画像/動画）",
    },
    attached_images: {
        th: "รูปภาพที่แนบ",
        en: "Attached Images",
        ja: "添付画像",
    },
    attached_videos: {
        th: "วิดีโอที่แนบ",
        en: "Attached Videos",
        ja: "添付動画",
    },
    attached_medias: {
        th: "สื่อที่แนบ",
        en: "Attached Medias",
        ja: "添付メディア",
    },

    // Image handling
    images_label: {
        th: "รูปภาพ",
        en: "Images",
        ja: "画像",
    },
    images_note: {
        th: "(.jpg .png, สูงสุด 5MB, ไม่เกิน 5 ไฟล์)",
        en: "(.jpg .png, up to 5MB, max 5 files)",
        ja: "(.jpg .png、最大10MB、最大10ファイル)",
    },
    add_image: {
        th: "เพิ่มรูปภาพ",
        en: "Add Image",
        ja: "画像を追加",
    },
    change_image: {
        th: "เปลี่ยนรูปภาพ",
        en: "Change Image",
        ja: "画像を変更",
    },
    drop_hint: {
        th: "ลากและวางรูปภาพที่นี่ หรือคลิกปุ่มเพิ่ม",
        en: "Drag and drop images here, or click Add",
        ja: "ここに画像をドラッグ＆ドロップ、または「追加」をクリック",
    },

    // Video handling
    videos_label: {
        th: "วิดีโอ",
        en: "Videos",
        ja: "動画",
    },
    videos_note: {
        th: "(.mp4 .webm .ogg .mov、สูงสุด 50MB ต่อไฟล์)",
        en: "(.mp4 .webm .ogg .mov, up to 50MB per file)",
        ja: "(.mp4 .webm .ogg .mov、ファイルごとに最大100MB)",
    },
    add_video: {
        th: "เพิ่มวิดีโอ",
        en: "Add Video",
        ja: "動画を追加",
    },

    // Upload limits and errors
    max_images_exceeded: {
        th: "สามารถอัปโหลดได้สูงสุด {{maxImages}} รูปภาพเท่านั้น",
        en: "You can upload up to {{maxImages}} images only",
        ja: "画像は最大{{maxImages}}枚までアップロードできます",
    },
    max_videos_exceeded: {
        th: "สามารถอัปโหลดได้สูงสุด {{maxVideos}} วิดีโอเท่านั้น",
        en: "You can upload up to {{maxVideos}} videos only",
        ja: "動画は最大{{maxVideos}}本までアップロードできます",
    },

    // Preview functionality
    board_preview: {
        th: "ตัวอย่าง",
        en: "Preview",
        ja: "プレビュー",
    },
    board_preview_badge: {
        th: "พรีวิว",
        en: "Preview",
        ja: "プレビュー",
    },
    board_preview_note: {
        th: "หมายเหตุ: นี่เป็นเพียงตัวอย่างการแสดงผลจริงอาจแตกต่างกันไปตามสไตล์ของเว็บไซต์",
        en: "Note: This is just a preview. Actual rendering may vary based on website styles.",
        ja: "注意：これはプレビューに過ぎません。実際のレンダリングはウェブサイトのスタイルによって異なる場合があります。",
    },

    // Loading states for files
    loading_processing: {
        th: "กำลังประมวลผล...",
        en: "Processing...",
        ja: "処理中...",
    },
    loading_uploading: {
        th: "กำลังอัปโหลด...",
        en: "Uploading...",
        ja: "アップロード中...",
    },
    loading_preparing: {
        th: "กำลังเตรียมตัวอย่าง...",
        en: "Preparing preview...",
        ja: "プレビュー準備中...",
    },
    loading_rotating: {
        th: "กำลังหมุนรูปภาพ...",
        en: "Rotating image...",
        ja: "画像回転中...",
    },
    loading_rotating_short: {
        th: "หมุน...",
        en: "Rotating...",
        ja: "回転中...",
    },
    loading_image: {
        th: "กำลังโหลดรูปภาพ...",
        en: "Loading image...",
        ja: "画像読込中...",
    },
    loading_image_short: {
        th: "โหลด...",
        en: "Loading...",
        ja: "読込中...",
    },
    loading_submitting: {
        th: "กำลังส่งข้อมูล...",
        en: "Submitting data...",
        ja: "データ送信中...",
    },

    // File actions
    save: {
        th: "บันทึก",
        en: "Save",
        ja: "保存",
    },
    saving: {
        th: "กำลังบันทึก...",
        en: "Saving...",
        ja: "保存中...",
    },
    cancel: {
        th: "ยกเลิก",
        en: "Cancel",
        ja: "キャンセル",
    },

    // SNS Links (form)
    sns_links_note_auto: {
        th: "เนื้อหาที่ใส่ใน Content จะถูกตรวจจับลิงก์ SNS และเพิ่มอัตโนมัติ (ไม่แก้ไขเนื้อหา)",
        en: "SNS links typed/pasted in Content are detected and added automatically (Content is not modified)",
        ja: "Contentに入力したSNSリンクを検出して自動追加します（Content自体は変更しません）",
    },
};

export { dictAttachments };
